<template>
  <vue-button class="btn btn-outline btn-primary"
              icon="view-solid"
              :status="status"
              @click="handleClick">Tout marquer comme lu</vue-button>
</template>

<script>
/* globals axios route */

import ErrorHandler from '../../core/ErrorHandler';

export default {
  data() {
    return {
      status: null,
    };
  },

  methods: {
    handleClick() {
      this.status = 'loading';
      axios
        .delete(route('api.notifications.destroy'))
        .then(() => this.onSuccess())
        .catch(error => this.onFail(error));
    },

    onSuccess() {
      this.status = 'succeeded';
      this.$emit('done');
      setTimeout(() => {
        this.status = null;
      }, 1500);
    },

    onFail(error) {
      this.status = 'failed';
      new ErrorHandler(error).dispatch();
      setTimeout(() => {
        this.status = null;
      }, 1500);
    },
  },
};
</script>
